import { useMutation } from '@tanstack/react-query'

import { updateUserPassword } from '@src/api'
import { DefaultApiUpdateUserPasswordRequest } from '@src/api/generated/iam'
import { useAxios } from '@src/hooks'

export const useUpdatePassword = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  // Unknown error response type forced to use any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useMutation<unknown, any, DefaultApiUpdateUserPasswordRequest>({
    mutationFn: (params: DefaultApiUpdateUserPasswordRequest) =>
      updateUserPassword(axiosInstance, params),
  })
}
